import request from '@/utils/request'

// 获取事件源列表
export const getEventSourceLists = (data) => {
    return request({
        url: '/event/source/lists',
        params: data
    })
}

// 获取事件源选项列表
export const getEventSourceOptionLists = (data) => {
    return request({
        url: '/event/source/option/lists',
        params: data
    })
}

// 获取事件源选项
export const getEventSourceOptions = (data) => {
    return request({
        url: '/event/source/options',
        params: data
    })
}

// 事件源-详情
export const getEventSourceDetail = (id) => {
    return request({
        url: `/event/source/${id}`
    })
}

// 事件源-修改
export const putEventSource = (data) => {
    return request({
        url: '/event/source/manage',
        method: 'PUT',
        data
    })
}

// 事件源-添加
export const addEventSource = (data) => {
    return request({
        url: '/event/source/manage',
        method: 'POST',
        data
    })
}

// 事件源-删除
export const delEventSource = (id) => {
    return request({
        url: `/event/source/${id}`,
        method: 'DELETE'
    })
}

/**
 * 摄像头选项-能力级&摄像头类型
 */
export const getCapabilityCameraType = () => {
    return request({
        url: '/camera/options'
    })
}

// 批量处理时间源
export const batchEvnetManage = (method, data) => {
    return request({
        url: '/event/source/manage',
        method: 'PATCH',
        data: {
            method,
            data
        }
    })
}
